import React from 'react';
import Navbar from '../Navbar/Navbar';
import "./Header.css";
import logoFull from '../../assets/images/logo-full.png'; // adjust path and filename as needed


const Header = () => {
  return (
    
    <header className='header flex flex-center flex-column'>
      <div >
          <img
  src={logoFull}
  alt="Insurance Consultancy Nepal Pvt. Ltd."
  style={{
     width: "60%",
    maxWidth: "65%",
    height: "auto",
    objectFit: "contain",
    display: "block",
    margin: "100px auto"
  }}
/>
</div>
        <Navbar />
         
   
          <div className='container'>
            <div className='header-content text-center flex flex-column'>
                <h1 className='text-uppercase header-title'>Delivering Complete Insurance Solutions with Innovation, Integrity, and Insight</h1>
                <p className='text-lead'>We are pure Insurance Consultants. We are not Insurance Agent and Insurance Surveyor. We’re your long-term insurance portfolio partners, striving every day to enhance service quality, client performance, and national impact.</p>
                
            </div>
        </div>
    </header>
  )
}

export default Header